import { render, staticRenderFns } from "./PropostaPrecoDetalhe.vue?vue&type=template&id=0d4d6d5e&scoped=true&"
import script from "./PropostaPrecoDetalhe.vue?vue&type=script&lang=js&"
export * from "./PropostaPrecoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./PropostaPrecoDetalhe.vue?vue&type=style&index=0&id=0d4d6d5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d6d5e",
  null
  
)

export default component.exports